import { Flex, Table, TableProps, Typography } from "antd";
import "./ProjectsDetails.scss";
import React from "react";
import { getProjectsDetailsColumns } from "projects/constants";
import { useBoundStore } from "store";
import { IProjectDetails } from "projects/models";
import { utilityService } from "shared/services";

import variables from "../../../_variables.scss";

type Props = {
  projectsDetails: IProjectDetails[];
  dataLoading?: boolean;
};

export const ProjectsDetails = ({ projectsDetails, dataLoading }: Props) => {
  const { currentOrganization } = useBoundStore();
  const tblRef: Parameters<typeof Table>[0]["ref"] = React.useRef(null);
  const tableColumns = getProjectsDetailsColumns(currentOrganization);
  const tableProps: TableProps<IProjectDetails> = {
    loading: dataLoading,
  };

  return (
    <Flex vertical gap={variables.gap} data-testid='projectsDetails'>
      <h2>My Projects Details</h2>
      <Table
        className='projects-details-table'
        {...tableProps}
        columns={tableColumns}
        dataSource={projectsDetails}
        ref={tblRef}
        rowKey='id'
        pagination={false}
        summary={(pageData) => {
          let totalProjectValue = 0;

          pageData.forEach(({ projectValue }) => {
            totalProjectValue += Number(projectValue ?? 0);
          });

          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                  <Typography.Text strong>TOTALS</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                  <Typography.Text strong>
                    ${utilityService.statisticsFormatter(totalProjectValue)}
                  </Typography.Text>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
        scroll={{
          y: variables.defaultComponentHeight,
        }}
      />
    </Flex>
  );
};
